/** Landing path from account / setup-checklist API (07-09: checklist is home until live). */

export const SETUP_CHECKLIST_PATH = '/setup-checklist';
export const ACCOUNT_OVERVIEW_PATH = '/account-overview';

const NOT_LIVE_STATUSES = new Set(['PROSPECT', 'PENDING_SETUP']);
/** 10-06 GET /account `state` plus live aliases. CLOSED is post-setup, not the checklist. */
const LIVE_STATUSES = new Set(['ACTIVE', 'LIVE', 'CREDIT_HOLD', 'SUSPENDED', 'CLOSED']);

export function isBusinessAccountLive(input: {
  status?: string | null;
  state?: string | null;
  onboardedAt?: string | null;
  setupProgress?: number | null;
  checklistProgress?: number | null;
}): boolean {
  if (input.onboardedAt) return true;
  const status = (input.status ?? input.state ?? '').trim().toUpperCase();
  if (NOT_LIVE_STATUSES.has(status)) return false;
  if (LIVE_STATUSES.has(status)) return true;
  const progress = input.checklistProgress ?? input.setupProgress;
  if (typeof progress === 'number') return progress >= 100;
  return false;
}

export function landingPathForAccount(input: {
  status?: string | null;
  state?: string | null;
  onboardedAt?: string | null;
  setupProgress?: number | null;
  checklistProgress?: number | null;
}): string {
  return isBusinessAccountLive(input) ? ACCOUNT_OVERVIEW_PATH : SETUP_CHECKLIST_PATH;
}
